(function () {
  'use strict';

  var ALLOWED = /^[\p{L}\p{M}\p{N}][\p{L}\p{M}\p{N} '’.\-]*$/u;

  class PersonalizationFields extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('[data-personalization-name]');
      if (!this.input) return;
      this.form = this.closest('form');
      this.error = this.querySelector('[data-personalization-error]');
      this.counter = this.querySelector('[data-counter]');
      this.dialog = this.querySelector('[data-dialog]');
      this.summary = this.querySelector('[data-summary]');
      this.cardError = this.querySelector('[data-card-error]');
      this.modalError = this.querySelector('[data-modal-error]');
      this.openButton = this.querySelector('[data-open]');
      this.max = parseInt(this.getAttribute('data-max'), 10) || 12;

      this.optional = this.hasAttribute('data-optional');
      this.phraseInput = this.querySelector('[data-phrase-input]');
      this.phraseFee = this.querySelector('[data-phrase-fee]');
      this.phraseToken = this.querySelector('[data-phrase-token]');
      this.imageInput = this.querySelector('[data-image-input]');
      this.rightsInput = this.querySelector('[data-rights-input]');
      this.imageFee = this.querySelector('[data-image-fee]');
      this.imageToken = this.querySelector('[data-image-token]');
      this.art = null;
      this.setupTabs();

      if (this.imageInput) {
        this.imageInput.addEventListener('change', this.onImage.bind(this));
        this.querySelector('[data-image-remove]').addEventListener('click', this.removeImage.bind(this));
        this.rightsInput.addEventListener('change', function () {
          if (this.rightsInput.checked) this.setImageError('');
        }.bind(this));
      }
      if (this.phraseInput) this.phraseInput.addEventListener('input', this.onPhrase.bind(this));

      if (this.form) {
        this.form.noValidate = true;
        this.form.addEventListener('submit', this.onSubmit.bind(this));

        this.form.addEventListener('cart:added', function () {
          if (this.art) this.setToken(this.imageToken, true);
          if (this.hasPhrase()) this.setToken(this.phraseToken, true);
        }.bind(this));
      }
      this.input.addEventListener('input', this.onInput.bind(this));
      this.openButton.addEventListener('click', this.open.bind(this));
      this.querySelectorAll('[data-cancel]').forEach(function (button) {
        button.addEventListener('click', this.cancel.bind(this));
      }, this);
      this.querySelector('[data-save]').addEventListener('click', this.save.bind(this));
      this.dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        this.cancel();
      }.bind(this));
      this.input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.save();
        }
      }.bind(this));

      this.onInput();
      this.updateSummary();
    }

    length(value) {
      return Array.from(value).length;
    }

    phraseValue() {
      return this.phraseInput ? this.phraseInput.value.trim() : '';
    }

    hasPhrase() {
      return Boolean(this.phraseValue());
    }

    setToken(token, on) {
      if (!token) return;
      token.disabled = !on;
      token.value = on ? Date.now().toString(36) + Math.random().toString(36).slice(2, 8) : '';
    }

    setupTabs() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-tab]'));
      this.tabs.forEach(function (tab, index) {
        tab.addEventListener('click', this.selectTab.bind(this, tab.getAttribute('data-tab'), false));
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (next === null) return;
          event.preventDefault();
          this.selectTab(this.tabs[next].getAttribute('data-tab'), true);
        }.bind(this));
      }, this);
    }

    selectTab(name, focus) {

      if (!this.tabs.some(function (tab) { return tab.getAttribute('data-tab') === name; })) return;
      this.tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-tab') === name;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        if (on && focus) tab.focus();
      });
      this.querySelectorAll('[data-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-panel') !== name;
      });
    }

    onPhrase() {
      var has = this.hasPhrase();
      if (this.phraseFee) this.phraseFee.checked = has;

      if (this.phraseToken && has === this.phraseToken.disabled) this.setToken(this.phraseToken, has);
      var dot = this.querySelector('[data-phrase-dot]');
      if (dot) dot.hidden = !has;
    }

    onImage() {
      var file = this.imageInput.files && this.imageInput.files[0];
      if (!file) {
        this.clearArt();
        return;
      }
      if (!/^image\/(png|jpeg)$/.test(file.type)) return this.rejectImage(this.getAttribute('data-image-wrong-type'));
      if (file.size > 15 * 1024 * 1024) return this.rejectImage(this.getAttribute('data-image-too-big'));
      this.setImageError('');
      this.loadArt(file);
    }

    loadArt(file) {
      if (this.art && this.art.url) URL.revokeObjectURL(this.art.url);
      var url = URL.createObjectURL(file);
      var probe = new Image();
      probe.onload = function () {
        this.art = { url: url, width: probe.naturalWidth, height: probe.naturalHeight, file: file };
        if (this.imageFee) this.imageFee.checked = true;
        this.setToken(this.imageToken, true);
        this.querySelector('[data-image-thumb]').src = url;
        this.querySelector('[data-image-name]').textContent = file.name;
        this.querySelector('[data-image-preview]').hidden = false;
        this.querySelector('[data-image-remove]').hidden = false;
        this.querySelector('[data-image-rights]').hidden = false;
        this.querySelector('[data-image-dot]').hidden = false;
        this.querySelector('[data-image-choose]').textContent = this.getAttribute('data-image-change');
        this.rightsInput.disabled = false;

        this.querySelector('[data-image-warning]').hidden = Math.max(probe.naturalWidth, probe.naturalHeight) >= 1200;
      }.bind(this);
      probe.onerror = function () {
        this.rejectImage(this.getAttribute('data-image-wrong-type'));
      }.bind(this);
      probe.src = url;
    }

    rejectImage(message) {
      this.imageInput.value = '';
      this.clearArt();
      this.setImageError(message);
    }

    removeImage() {
      this.imageInput.value = '';
      this.clearArt();
      this.querySelector('[data-image-choose]').focus();
    }

    clearArt() {
      if (this.art && this.art.url) URL.revokeObjectURL(this.art.url);
      this.art = null;
      if (this.imageFee) this.imageFee.checked = false;
      this.setToken(this.imageToken, false);
      this.querySelector('[data-image-preview]').hidden = true;
      this.querySelector('[data-image-remove]').hidden = true;
      this.querySelector('[data-image-rights]').hidden = true;
      this.querySelector('[data-image-warning]').hidden = true;
      this.querySelector('[data-image-dot]').hidden = true;
      this.querySelector('[data-image-choose]').textContent = this.getAttribute('data-image-choose');
      this.rightsInput.checked = false;
      this.rightsInput.disabled = true;
    }

    setImageError(message) {
      var box = this.querySelector('[data-image-error]');
      if (!box) return;
      box.textContent = message || '';
      box.hidden = !message;
    }

    restoreFile(file, rights) {
      if (!this.imageInput) return;
      if (!file) {
        this.imageInput.value = '';
        this.clearArt();
        return;
      }
      try {
        var transfer = new DataTransfer();
        transfer.items.add(file);
        this.imageInput.files = transfer.files;
        this.loadArt(file);
        this.rightsInput.checked = Boolean(rights);
      } catch (e) {
        this.imageInput.value = '';
        this.clearArt();
      }
    }

    onInput() {
      if (this.counter) {
        this.counter.textContent = this.getAttribute('data-counter-template').replace('__COUNT__', String(this.length(this.input.value)));
      }
      if (this.input.getAttribute('aria-invalid') === 'true' && !this.check(this.input.value.trim())) this.clearError();
    }

    snapshot() {
      return {
        name: this.input.value,
        phrase: this.phraseInput ? this.phraseInput.value : '',
        file: this.art ? this.art.file : null,
        rights: this.rightsInput ? this.rightsInput.checked : false,
      };
    }

    open() {
      this.saved = this.snapshot();
      this.dialog.showModal();
      document.documentElement.classList.add('has-personalize-modal');
      window.requestAnimationFrame(function () {
        var first = this.querySelector('[data-panel]:not([hidden]) input:not([type="hidden"]):not(.visually-hidden), [data-panel]:not([hidden]) textarea');
        if (first) first.focus();
      }.bind(this));
    }

    close() {
      this.dialog.close();
      document.documentElement.classList.remove('has-personalize-modal');
      this.openButton.focus();
    }

    cancel() {
      if (this.saved) {
        this.input.value = this.saved.name;
        if (this.phraseInput) {
          this.phraseInput.value = this.saved.phrase;
          this.onPhrase();
        }
        var current = this.art ? this.art.file : null;
        if (current !== this.saved.file) this.restoreFile(this.saved.file, this.saved.rights);
        else if (this.rightsInput) this.rightsInput.checked = this.saved.rights;
      }
      this.clearError();
      this.setImageError('');
      this.onInput();
      this.close();
    }

    save() {
      if (!this.validate(true)) return;
      this.updateSummary();
      this.close();
    }

    validate(focus) {
      var value = this.normalized();
      this.normalizePhrase();
      var hasAny = Boolean(value) || this.hasPhrase() || Boolean(this.art);
      if (this.optional && !hasAny) {
        this.clearError();
        this.setImageError('');
        return true;
      }
      if (!hasAny) {
        if (this.hasTab('name')) {
          this.selectTab('name', false);
          this.showError(this.getAttribute('data-required-any'));
          if (focus) this.input.focus();
        } else {

          this.showModalError(this.getAttribute('data-required-any'));
        }
        return false;
      }
      if (value) {
        var message = this.check(value);
        if (message) {
          this.selectTab('name', false);
          this.showError(message);
          if (focus) this.input.focus();
          return false;
        }
      }
      this.clearError();
      if (this.art && !this.rightsInput.checked) {
        this.selectTab('image', false);
        this.setImageError(this.getAttribute('data-rights-required'));
        if (focus) this.rightsInput.focus();
        return false;
      }
      this.setImageError('');
      return true;
    }

    updateSummary() {
      var value = this.input.value.trim();
      var phrase = this.phraseValue();
      var has = Boolean(value) || Boolean(phrase) || Boolean(this.art);
      if (has) {
        var parts = [];
        if (value) parts.push(value);
        if (phrase) parts.push(this.getAttribute('data-phrase-summary'));
        if (this.art) parts.push(this.getAttribute('data-image-summary'));
        this.summary.textContent = parts.join(' · ');
      } else {
        this.summary.textContent = this.getAttribute('data-empty-summary');
      }
      this.summary.classList.toggle('is-filled', has);
      this.openButton.textContent = this.getAttribute(has ? 'data-edit-label' : 'data-open-label');
      if (has && this.cardError) this.cardError.hidden = true;
    }

    normalized() {
      var value = this.input.value.trim().replace(/\s+/g, ' ');
      try {
        value = value.normalize('NFC');
      } catch (e) {}
      this.input.value = value;
      return value;
    }

    normalizePhrase() {
      if (!this.phraseInput) return;
      var value = this.phraseInput.value.trim().replace(/\s+/g, ' ');
      try {
        value = value.normalize('NFC');
      } catch (e) {}
      this.phraseInput.value = value;
      this.onPhrase();
    }

    check(value) {
      if (!value) return this.getAttribute('data-required-message');
      if (this.length(value) > this.max) return this.getAttribute('data-too-long-message');
      try {
        if (!ALLOWED.test(value)) return this.getAttribute('data-invalid-message');
      } catch (e) {}
      return '';
    }

    showError(message) {
      this.input.setAttribute('aria-invalid', 'true');
      if (this.error) {
        this.error.textContent = message;
        this.error.hidden = false;
      }
    }

    hasTab(name) {
      return this.tabs.some(function (tab) { return tab.getAttribute('data-tab') === name; });
    }

    showModalError(message) {
      if (!this.modalError) return;
      this.modalError.textContent = message;
      this.modalError.hidden = false;
    }

    clearError() {
      if (this.modalError) {
        this.modalError.textContent = '';
        this.modalError.hidden = true;
      }
      this.input.removeAttribute('aria-invalid');
      if (this.error) {
        this.error.textContent = '';
        this.error.hidden = true;
      }
    }

    onSubmit(event) {
      if (this.validate(false)) {

        var empty = [
          !this.input.value.trim() ? this.input : null,
          this.phraseInput && !this.hasPhrase() ? this.phraseInput : null,
          this.imageInput && !this.art ? this.imageInput : null,
        ].filter(Boolean);
        empty.forEach(function (input) { input.disabled = true; });
        window.setTimeout(function () {
          empty.forEach(function (input) { input.disabled = false; });
        }, 0);
        return;
      }
      event.preventDefault();
      if (this.cardError) {
        var fieldError = this.error && !this.error.hidden ? this.error.textContent : this.getAttribute('data-rights-required');
        this.cardError.textContent = fieldError;
        this.cardError.hidden = false;
      }
      var tab = this.tabs.find(function (t) { return t.getAttribute('aria-selected') === 'true'; });
      this.open();
      if (tab) this.selectTab(tab.getAttribute('data-tab'), false);
    }
  }

  if (!customElements.get('personalization-fields')) {
    customElements.define('personalization-fields', PersonalizationFields);
  }
})();
